import { render, staticRenderFns } from "./CommonActionSheet.vue?vue&type=template&id=13485d05&scoped=true"
import script from "./CommonActionSheet.vue?vue&type=script&lang=js"
export * from "./CommonActionSheet.vue?vue&type=script&lang=js"
import style0 from "./CommonActionSheet.vue?vue&type=style&index=0&id=13485d05&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13485d05",
  null
  
)

export default component.exports